import * as React from "react";
import {clientAppSettings} from "../../Models/ClientAppSettings";
import {BotTypes} from "../../Utils/BotUtils";
import {resourceStrings, FooterControl} from "../../../../Intercom.ReactUI/Views/index";
import {lazy} from "../../Decorators/index";

export interface BotCreateSwitchProps extends React.Props<BotCreateSwitch> {
    createFirstBot: boolean;
    showAbsGACreate: boolean;
    onCreate(botTypes: BotTypes) : void;
}

export interface BotCreateSwitchState {
}

interface CreateTile {
    title: string,
    description: string | Function,
    button: string,
    botType: BotTypes;
}


export class BotCreateSwitch extends React.Component<BotCreateSwitchProps, BotCreateSwitchState> {
    private tiles: CreateTile[];

    @lazy()
    private get absCodeEnabled() : boolean {
        return clientAppSettings.flightedFeatures.indexOf('absCode') >= 0;
    }

    @lazy()
    private get showTiles() : boolean {
        return this.absCodeEnabled;
    }

    private get absCodeTile() : CreateTile {
        return {
            title: 'Create a bot with the Bot Builder SDK',
            description: 'Click create below to use the SDK to build your bot and optionally host it in Microsoft Azure.',
            button: 'Create',
            botType: BotTypes.None
        }
    }

    constructor(props) {
        super(props);
        this.tiles = [];

        if(props.showAbsGACreate) {
            this.tiles.push({
                title: 'Create a bot with the Azure Bot Service',
                description: () => { return (
                    <p>Create a new bot or register an existing bot with the Azure Bot Service.</p>
                    );},
                button: 'Create',
                botType: BotTypes.ABSGACreate
            });
        } else {
            this.tiles.push(this.absCodeEnabled ? this.absCodeTile : {
                title: 'Create a bot with the Bot Builder SDK',
                description: () => { return (
                    <p>Don't have the SDK yet? <a href="//aka.ms/bf-createsdkbot" target="_blank">Download</a>, build, then return to this page to register.</p>
                    );},
                button: 'Register',
                botType: BotTypes.None
            });
        }

        this.state = {
        };
    }

    public componentDidMount() {
        if (this.showTiles) {
            $('body').toggleClass('dark-gray', true);
        }
    }

    public componentWillUnmount() {
        if (this.showTiles) {
            $('body').toggleClass('dark-gray', false);
        }
    }

    private renderCreateTile(tile: CreateTile): JSX.Element {
        return (
            <div className="bot-create-tile" key={`bot_create_type_${tile.botType}`}>
                <div className={`icon ${BotTypes[tile.botType]}`}></div>
                <div className="tile-text">
                    <h3>{tile.title}</h3>
                    <p>{(tile.description instanceof Function) ? (tile.description as Function)() : tile.description }</p>
                </div>
                <button className="m-button-primary-md create-bot-btn" onClick={() => this.props.onCreate(tile.botType) }>{tile.button}</button>
            </div>
        );
    }

    public render(): JSX.Element {
        return (
            <div className="outline bot-create-switch-outter">
                <div className="description">
                    <h2>{this.props.createFirstBot ? resourceStrings.v4.nobotsPrompt : resourceStrings.v4.newBotPrompt}</h2>
                    <p>
                        {this.showTiles? null : <a href='//aka.ms/bf-createsdkbot' target='_blank'>{resourceStrings.v4.createBotSDKLink}&nbsp;</a>}
                        {resourceStrings.v4.createBotLabel}
                    </p>
                </div>
                { this.showTiles ?  this.renderCreateTiles() : this.renderRegisterButton()}
                <FooterControl />
            </div>
        );
    }

    private renderRegisterButton(): JSX.Element {
        return (
            <button className='m-button-primary-md' onClick={() => this.props.onCreate(BotTypes.None) }>{resourceStrings.register}</button>
        );
    }


    public renderCreateTiles(): JSX.Element {
        return (
            <div className="bot-create-switch">
                {this.tiles.map(x => this.renderCreateTile(x))}
            </div>
        );
    }

}




// WEBPACK FOOTER //
// ./Client/v4/Views/BotCreateSwitch.tsx